import React from 'react'
import format from "../img/logo3.png";
import women from "../img/women1.jpg";

export default function Womenclub() {
  return (
    <div>
    {/* <main className="page-wrapper"> */}
        {/* <section className="container pt-5 pb-lg-2 pb-xl-4 py-xxl-5 my-5"> <br/> */}
       

        <section className="bg-primary position-relative py-5"> <br/>
        <div className="d-none d-dark-mode-block position-absolute top-0 start-0 w-100 h-100" ></div>
        <div className="container dark-mode position-relative zindex-2 py-5 mb-4 mb-sm-5">
        <div className="d-lg-flex position-relative h-100" style={{ position: "relative" }}>
          <a className="text-nav btn btn-icon bg-light border rounded-circle position-absolute top-0 end-0 p-0 mt-3 me-3 mt-sm-4 me-sm-4" href="/" data-bs-toggle="tooltip" data-bs-placement="left" title="Back to home"><i className="ai-home"></i></a>
        </div>
          <div className="row pb-5 mb-2 mb-sm-0 mb-lg-3">
            <div className="">
              <h1 className="display-4 pb-2 pb-sm-3">ЖЕНСКИЙ КЛУБ</h1>
              <p className='display-6'><strong>Women_art_trick </strong> — это пространство, где женщины могут найти поддержку, вдохновение и ресурсы для личного и профессионального роста.</p>
              <ul className="list-unstyled d-flex flex-wrap mb-0">
                <li className="d-flex py-1 me-4 fs-lg"><i className="ai-check-alt text-success lead me-2"></i>Сохраняет время и силы</li>
                <li className="d-flex py-1 me-4 fs-lg"><i className="ai-check-alt text-success lead me-2"></i>Восполняет общение</li>
                <li className="d-flex py-1 me-4 fs-lg"><i className="ai-check-alt text-success lead me-2"></i>Дает развиваться</li>
                <li className="d-flex py-1 fs-lg"><i className="ai-check-alt text-success lead me-2"></i>Поможет семье сохранить баланс</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* About*/}
      <section className="container position-relative zindex-3" style={{marginTop: '-135px'}}>
        <div className="rounded-5 overflow-hidden"> 
          <div className="jarallax ratio ratio-16x9" datajarallax dataspeed="0.6">
            <div className="jarallax-img" style={{backgroundImage: 'url(assets/img/landing/corporate/women.jpg)'}}></div>
          </div>
        </div>
        <div className="row pt-5 mt-n2 mt-sm-0 mt-md-2 mt-lg-4 mt-xl-5">
          <div className="col-md-6 col-lg-5">
            <div className="fs-sm text-uppercase mb-3">Что мы делаем</div>
            <h4 className="mb-lg-4">Женский клуб Women art trick работает активно с 28.11.2020 года.</h4>
            <h3 className="mb-lg-4"><strong>  Форматы участия: </strong> </h3>
             <ol className="fs-xl mb-0">
              <li>Индивидуальное участие позволяет сосредоточиться на собственных целях и задачах.</li>
              <li>Групповое участие создает атмосферу коллективной работы и взаимной поддержки.</li>
             </ol>
               <br/>
              <div className="mb-4">
                 <img className="rounded-5" src={women} alt="Ima"/>
              </div>
          </div>
          <div className="container col-md-7 col-xl-6 pt-1 pt-sm-2 pt-md-5">
            <p className="fs-xl">Основанный на идее объединения женщин с разными интересами и потребностями, клуб предлагает разнообразные мероприятия и активности, способствующие развитию и самореализации. </p>
            <p className="fs-xl"> <strong> Основные направления деятельности клуба:</strong></p>
            <ul className="fs-xl mb-0">
            <li ><strong>Сохранение времени и сил:</strong> Клуб объединяет несколько направлений, позволяя женщинам экономить время и силы, получая доступ к различным услугам и возможностям в одном месте. </li>
            <li ><strong>Восполнение общения: </strong> Нетворкинг и полезные знакомства с другими участниками клуба способствуют расширению социальных связей и обмену опытом. </li>
            <li ><strong>Развитие и обучение: </strong> Тренинги, коуч-сессии и мастер-классы предоставляют возможности для личностного роста и повышения квалификации.</li>
            <li ><strong>Поддержка семьи: </strong> Мероприятия направлены на развитие детей, продвижение бизнеса и карьерного роста супругов, что укрепляет семью в целом.</li>
            </ul>      
          </div>
        </div>
      </section>
      <section className="pt-5 mt-md-2 mt-xl-4">
        <div className="container pt-2 pt-sm-4 pt-lg-5 mt-xxl-2">
          <div className="fs-sm text-uppercase mb-3">Наша миссия</div>
          <h3 className="pb-3 mb-lg-4">ЕСТЬ ВОЗМОЖНОСТЬ К НАМ ПОПАСТЬ: ИНДИВИДУАЛЬНО ИЛИ В ГРУППУ </h3>
          <div className="card border-0 bg-secondary rounded-5 h-300 p-3">
            <div className="card-body">
              <img
              className="float-start me-3 mb-3 rounded-circle"
              src={format}
              alt=""
              width="80"
              height="80"/>
              <p className="h5">
               Рублева Анна, создатель и основатель Women_art_trick, подчеркивает важность самореализации и любви для женщин, делая акцент на полезности пространства для роста и развития личности.
              </p>
              <p className="mb-0 fs-xl">
              «Занимаясь частной практикой в коучинге, я поняла, что у женщин в основном схожие сложности. Поэтому, первоочередная задача Клуба - быть полезным пространством для роста и развития»
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="container pt-3 pb-3 mb-3 mt-1 mt-sm-2 mt-xl-4 mt-xxl-5">
        <div className="row align-items-center pt-2 pt-sm-3 pt-md-4 pt-lg-5 mt-xl-2 mt-xxl-3">
          <div className="col-md-6 col-xl-5 pb-3 pb-md-0 mb-4 mb-md-0">
            <div className="ratio ratio-1x1 d-flex align-items-center position-relative rounded-circle overflow-hidden bg-size-cover mx-auto" style={{maxWidth: '530px', backgroundImage: 'url(assets/img/landing/corporate/women33.png)'}}>
              <div className="bg-black position-absolute top-0 start-0 w-100 h-100 opacity-50"></div>
              <div className="dark-mode position-relative zindex-2 p-4">
                <div className="text-center mx-auto" style={{maxWidth: "275px"}}>
                    <span className="d-block fs-sm text-uppercase mb-3">Как мы организуем</span>
                  <h2 className="display-6 mb-0">Ключ к успеху</h2>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6 col-xl-5 offset-xl-1">
            <div className="ps-md-4 ps-xl-0">
              <div className="steps steps-hoverable">
                <div className="step py-3 py-xl-4">
                  <div className="step-number">
                    <div className="step-number-inner">01</div>
                  </div>
                  <div className="step-body">
                    <h3 className="h5 pb-1 mb-2">Женский клуб является серьезным форматом для работы над собой и своими приоритетами, привлекающим как женщин, так и мужчин.</h3>
                    <p className="mb-0 fs-lg">Это ваша грамотная поддерживающая среда для достижения своих целей и «почва» для грамотных перемен.</p>
                  </div>
                </div>
                <div className="step py-3 py-xl-4">
                  <div className="step-number">
                    <div className="step-number-inner">02</div>
                  </div>
                  <div className="step-body">
                    <h3 className="h5 pb-1 mb-2">Клуб проводит различные форматы мероприятий,</h3>
                    <p className="mb-0 fs-lg">включая <strong>астер-классы, семинары, тренинги, коучинг, нейрографику и другие виды активностей.</strong> 
                    Каждое мероприятие сопровождается подготовкой рабочих тетрадей, раздаточного материала, презентаций и подбором полезных инструментов для работы над собой.
                    </p>
                  </div>
                </div>
                <div className="step py-3 py-xl-4">
                  <div className="step-number">
                    <div className="step-number-inner">03</div>
                  </div>
                  <div className="step-body">
                    <h3 className="h5 pb-1 mb-2">Вы к нам вступаете</h3>
                    <p className="mb-0 fs-lg">Мы с вами работаем и развиваемся.</p>
                  </div>
                </div>
                <div className="step py-3 py-xl-4">
                  <div className="step-number">
                    <div className="step-number-inner">04</div>
                  </div>
                  <div className="step-body">
                    <h3 className="h5 pb-1 mb-2">Основная цель клуба - </h3>
                    <p className="mb-0 fs-lg"> максимально быстро привести участников к их целям, создавая поддерживающую среду для достижения желаемых изменений.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <br/>
      </section>
     <section className="container">
        <div className="pt-2 pt-sm-4 pt-lg-5 mt-xxl-2">
          <div className="fs-sm text-uppercase mb-3">Как проходят мероприятия</div>
          <h3 className=" mb-lg-4">Расписание мероприятий необходимо уточнять у администратора. 
          <a className="btn btn-icon btn-lg btn-light btn-linkedin rounded-circle mx-2" href="https://t.me/women_art_trick"><i className="ai-telegram text-info"> </i> </a>
          <a className="btn btn-icon btn-md btn-light btn-linkedin rounded-circle mx-2" href="https://www.instagram.com/women_art_trick"><i className="ai-instagram text-warning"> </i> </a> 
          <a className="btn btn-icon btn-lg btn-light btn-linkedin rounded-circle mx-2" href="https://vk.com/thormayou"><i className="ai-vk text-success"> </i> </a> 
          </h3>
          <p className="fs-lg">
            Для первого посещения необходима предварительная запись по телефону: +7 (992) 300-65-23, +7 (992) 300-65-46. <br/>
            </p>
          <div>
           <h4 className="">Ждем вас на наших мероприятиях! <br/> С собой иметь хорошее настроение и желание прекрасно провести время!
           </h4>
          <br/>
          </div>
        </div>
      </section>
    </div>
  )
}
